import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MyUtils } from 'src/app/services/my-utils.service';
@Component({
  selector: 'app-message-snack',
  templateUrl: './message-snack.component.html',
  styleUrls: ['./message-snack.component.scss']
})
export class MessageSnackComponent implements OnInit {

  constructor(
    public snackBarRef: MatSnackBarRef<MessageSnackComponent>,
    private router: Router,
    public utils: MyUtils,
  ) { }

  ngOnInit(): void {
  }

  doDownload(){
    this.router.navigate(['/', 'downloads']);
  }

}
